<template>
    <div class="footer-area-wrapper" :class="FooterStyle">
        <div class="footer-area section-space--ptb_90">
            <div class="container">
                <div class="row footer-widget-wrapper">
                    <div class="col-lg-4 col-md-6 footer-widget">
                        <div class="footer-widget__logo mb-30">
                            <router-link to="/">
                                <img src="../assets/img/logo/logo-dark.png" class="img-fluid logo-dark" alt="logo">
                            </router-link>
                        </div>
                        <ul class="footer-widget__list">
                            <li>
                                <a href="mailto:info@luszol.com" class="hover-style-link">info@luszol.com</a>
                            </li>
                            <li>
                                <a href="https://www.luszol.com" target="_blank" class="hover-style-link hover-style-link--green">luszol.com</a>
                            </li>
                        </ul>
                    </div>          
                    <!-- <div class="col-lg-2 col-md-6 footer-widget">
                        <h6 class="footer-widget__title mb-20">Dejanos tu correo</h6>
                        <ul class="footer-widget__list">
                            <li>
                                <div id="mc_embed_signup">
                                <form
                                    action="https://risadsaluddigital.us13.list-manage.com/subscribe/post?u=8b530fa9ddc4c1fc83287919c&amp;id=bcd3460e98&amp;f_id=00fcf3e7f0" 
                                    method="post"
                                    id="mc-embedded-subscribe-form"
                                    name="mc-embedded-subscribe-form"
                                    class="validate"
                                    target="_blank"
                                    novalidate
                                >
                                    <div id="mc_embed_signup_scroll">
                                    <label for="mce-EMAIL"> </label>
                                    <input
                                        type="email"
                                        value=""
                                        name="EMAIL"
                                        class="email"
                                        id="mce-EMAIL"
                                        required
                                    />
                                    <div style="position: absolute; left: -5000px;" aria-hidden="true">
                                        <input
                                        type="text"
                                        name="b_5119408c70596654ef4da6c1a_987baf3d10"
                                        tabindex="-1"
                                        value=""
                                        />
                                    </div>
                                    <div class="clear">
                                        <input
                                        type="submit"
                                        value="Subscribete"
                                        name="subscribe"
                                        id="mc-embedded-subscribe"
                                        class="button"
                                        />
                                    </div>
                                    </div>
                                </form>
                                </div>
                            </li>
                        </ul>
                    </div> -->
                    <div class="col-lg-3 col-md-6 offset-lg-1 footer-widget">
                        <div class="twitter-feed-slider">
                            <div class="swiper-container twitter-feed-slider__container">
                                <div class="swiper-wrapper twitter-feed-slider__wrapper">
                                    <div class="swiper-slide twitter-feed-slider__single">
                                        <div class="tweet">
                                            <div class="tweet__text">
                                                 <span>Be part of the revolution</span>
                                                 <h2>Change the world</h2>
                                            </div>
                                            <a href="https://twitter.com/luszolsolar" target="_blank">
                                                <div class="tweet__info">
                                                    <h6 class="tweet__heading">luszolsolar</h6>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-copyright-area border-top section-space--ptb_30">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6 text-center text-md-start">
                        <span class="copyright-text">
                            &copy; 2024 <b>Luszol LLC</b> Made with <i class="fa fa-heart text-danger"></i> by <a href="https://silibrain.com"><b>Silibrain LLC</b></a>
                        </span>
                    </div>
                    <div class="col-md-6 text-center text-md-end">
                        <ul class="list ht-social-networks solid-rounded-icon">
                            <li class="item">
                                <a href="https://www.facebook.com/luszol" target="_blank" class="social-link"> <i class="fab fa-facebook social-link-icon"></i> </a>
                            </li>
                            <li class="item">
                                <a href="https://www.linkedin.com/company/luszolsolar" target="_blank" class="social-link"> <i class="fab fa-linkedin social-link-icon"></i> </a>
                            </li>
                            <li class="item">
                                <a href="https://www.instagram.com/luszolsolar" target="_blank" class="social-link"> <i class="fab fa-instagram social-link-icon"></i> </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ["FooterStyle"]
    }
</script>